export default __webpack_public_path__ + "static/RecueilAvis3-a81c82a34e63c6963af71f70bdf2fea8.png";